import { render, staticRenderFns } from "./AdminCode.vue?vue&type=template&id=935c3978&scoped=true&"
import script from "./AdminCode.vue?vue&type=script&lang=js&"
export * from "./AdminCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "935c3978",
  null
  
)

export default component.exports